(function () {
  'use strict';

  // The video frame morphs from its in-flow tilted spot to a fixed fullscreen
  // takeover and back, via a FLIP transform (the only way to smoothly animate
  // between in-flow and position:fixed). Mobile fills width, desktop fills
  // height (see the [data-expanded] rules in component-news-product-video.css).

  const DURATION = 450;

  function init() {
    const frames = document.querySelectorAll('[data-video-expandable]');
    for (let i = 0; i < frames.length; i++) {
      setup(frames[i]);
    }
  }

  function setup(frame) {
    if (frame.hasAttribute('data-video-ready')) {
      return;
    }
    frame.setAttribute('data-video-ready', '');

    const section = frame.closest('[data-section-type="news-product-video"]');
    if (!section) {
      return;
    }

    const elements = {
      iframe: frame.querySelector('[data-video-iframe]'),
      expand: frame.querySelector('[data-video-expand]'),
      close: section.querySelector('[data-video-close]'),
      backdrop: section.querySelector('[data-video-backdrop]')
    };

    const state = {
      expanded: false,
      animating: false,
      baseSrc: elements.iframe ? elements.iframe.getAttribute('src') : ''
    };

    function morph(toExpanded) {
      const first = frame.getBoundingClientRect();

      // Keep the glow/badge/white-frame hidden for the whole morph so they never
      // flash at fullscreen scale during the grow/shrink.
      frame.setAttribute('data-morphing', '');

      // Apply the final state so we can measure it.
      toggleData(frame, 'expanded', toExpanded);

      const last = frame.getBoundingClientRect();

      // Invert: make it appear where it was, then play to its natural spot.
      const dx = first.left - last.left;
      const dy = first.top - last.top;
      const sx = last.width ? first.width / last.width : 1;
      const sy = last.height ? first.height / last.height : 1;

      frame.style.transition = 'none';
      frame.style.transformOrigin = 'top left';
      frame.style.transform =
        'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')';

      frame.getBoundingClientRect(); // force the inverted state to apply

      // Double rAF: a single one sometimes batches the inverted state and the
      // play into one paint, which makes it snap instead of animate.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          frame.style.transition = 'transform ' + DURATION + 'ms ease';
          frame.style.transform = '';
        });
      });

      state.animating = true;
      window.setTimeout(function () {
        state.animating = false;
        frame.style.transition = '';
        frame.style.transform = '';
        frame.style.transformOrigin = '';
        frame.removeAttribute('data-morphing');
      }, DURATION + 40);
    }

    function expand() {
      if (state.expanded || state.animating) {
        return;
      }
      state.expanded = true;
      if (elements.backdrop) {
        elements.backdrop.hidden = false;
      }
      document.documentElement.style.overflow = 'hidden';
      morph(true);
      // Start playback only once the container has finished growing to full size.
      window.setTimeout(function () {
        if (state.expanded && elements.iframe) {
          elements.iframe.setAttribute('src', autoplaySrc(state.baseSrc));
        }
      }, DURATION + 60);
    }

    function collapse() {
      if (!state.expanded || state.animating) {
        return;
      }
      state.expanded = false;
      morph(false);
      window.setTimeout(function () {
        if (elements.iframe) {
          elements.iframe.setAttribute('src', state.baseSrc); // stop after the shrink finishes
        }
        if (elements.backdrop) {
          elements.backdrop.hidden = true;
        }
        document.documentElement.style.overflow = '';
      }, DURATION);
    }

    if (elements.expand) {
      elements.expand.addEventListener('click', expand);
    }
    if (elements.close) {
      elements.close.addEventListener('click', collapse);
    }
    if (elements.backdrop) {
      elements.backdrop.addEventListener('click', collapse);
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.expanded) {
        collapse();
      }
    });
  }

  function toggleData(el, key, force) {
    if (force) {
      el.setAttribute('data-' + key, 'true');
    } else {
      el.removeAttribute('data-' + key);
    }
  }

  function autoplaySrc(src) {
    if (!src) {
      return src;
    }
    const sep = src.indexOf('?') === -1 ? '?' : '&';
    return src + sep + 'autoplay=1&mute=1&playsinline=1';
  }

  document.addEventListener('DOMContentLoaded', init);
})();
